package com.milta.core.localization.translations.fr

import com.milta.core.localization.OcrScanStrings

internal val OcrScan = OcrScanStrings(
    scanTitle = "Scanner un document",
    reviewTitle = "Vérifier les données",
    fileSentSuffix = "envoyée à l'instant",
    analysingTitle = "Lecture du document…",
    analysingSubtitle = "Nous détectons les livraisons présentes sur la photo. Quelques secondes suffisent.",
    deliveriesDetectedSuffix = "livraisons détectées",
    toCompleteSuffix = "à compléter",
    reviewHint = "Complétez les livraisons signalées avant de les ajouter à la tournée",
    addressMissingWarning = "Adresse manquante",
    nameMissingWarning = "Nom manquant",
    recipientMissingPlaceholder = "Destinataire non détecté",
    phoneNotDetectedNote = "Téléphone non détecté — ajout non bloqué",
    deadlineLabelPrefix = "Heure limite",
    completeLinkLabel = "Compléter",
    addToRouteButtonPrefix = "Ajouter à la tournée",
    correctionRecipientLabel = "Destinataire",
    correctionAddressLabel = "Adresse",
    correctionPhoneLabel = "Téléphone",
    correctionDeadlineLabel = "Heure limite",
    attemptLabel = "Tentative",
    unreadableTitle = "Photo illisible.",
    unreadableMessage = "Nous n'avons détecté aucune livraison sur cette image — reprenez une photo cadrée et bien éclairée.",
    retakePhotoButton = "Reprendre une photo",
    manualEntryButton = "Saisir manuellement",
    maxAttemptsTitle = "Toujours illisible après 2 tentatives.",
    maxAttemptsMessage = "Complétez cette livraison manuellement, ou reprenez le scan avec un nouveau document.",
    retakeUnavailableLabel = "Reprendre une photo — indisponible",
    rateLimitTitle = "Trop de scans effectués récemment.",
    rateLimitMessage = "Réessayez un peu plus tard, ou complétez cette livraison manuellement en attendant.",
    rateLimitRetakeUnavailableLabel = "Reprendre une photo — indisponible pour l'instant",
)
